import { ApiV4BaseError } from '@/Factories/BookingkitApi/Errors/ApiV4BaseError';
import { ApiV4AxiosError } from '@/Factories/BookingkitApi/Errors/ApiV4AxiosError';

export class AppAuthorizationRequiredError extends ApiV4BaseError {
    constructor(message: string, code?: string, details?: Record<string, unknown>) {
        super(message, code, details);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, AppAuthorizationRequiredError);
        }

        this.name = 'AppAuthorizationRequiredError';
    }

    static fromAxiosError(originalError: ApiV4AxiosError) {
        return new AppAuthorizationRequiredError(
            `Api call failed with status code ${originalError.response?.status}`,
            originalError.response?.data?.error_code,
            originalError.response?.data?.error_details,
        );
    }
}
